var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"dismissible":"","elevation":"11","type":_vm.message.type},on:{"input":_vm.clickHandler}},[_vm._v(" "+_vm._s(_vm.message.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }